module.exports = __webpack_public_path__ + "img/saum_orange_ral2008.b453b185.jpg";